import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInitOptions } from "../interfaces/initoptions";

function initState(): IInitOptions {
    const setup: IInitOptions = (<any> window).initOptions;
    return setup;
}

const initOptionsSlice = createSlice({
    name: "initOptions",
    initialState: initState,
    reducers: {},
});

export const {} = initOptionsSlice.actions;

export default initOptionsSlice.reducer;
